import {UvsModuleModel} from "../uvs-module.model";

export class SensorsOutsideTempModel {
  otmModules: UvsModuleModel[];
  directControl: {
    enabled: boolean;
    type: string;
  }

  constructor() {
    this.otmModules = [];
    this.directControl = {
      enabled: null,
      type: ''
    };
  }

  public static initialize(model: SensorsOutsideTempModel): void {
    if (!model.otmModules) {
      model.otmModules = [];
    }
    if (!model.directControl) {
      model.directControl = {
        enabled: null,
        type: ''
      };
    }
  }
}
